import React, { useState } from "react"
import Arrow from './../images/icons/drop-down.png'

const FaqItem = ({ item, index }) => {
  const [expanded, setExpanded] = useState(false)
  return (
    <React.Fragment>
      <div className="flexed justify-between align-c button px-16" onClick={() => setExpanded(!expanded)}>
        <h4 className="text-shadow font-15 my-32 iran-sans-light">{index + 1}. {item.title}</h4>
        <img className="icon-sm ml-8" src={Arrow} alt="" {...(expanded ? { style: { transform: 'rotate(180deg)' } } : {})} />
      </div>
      {item.text && expanded && <p className="px-32 pb-16 slideInBottom font-13 mt-0" style={{ lineHeight: 2.4 }}>{item.text}</p>}
    </React.Fragment>
  )
}

export default ({ list }) => {
  return (

    <div className="px-32" style={{ backgroundColor: '#f1f1f1' }}>
      {
        list.map((item, index) => (
          <React.Fragment key={index}>
            <div>
              <FaqItem key={index} item={item} index={index} />
              {(index + 1) !== list.length && <hr className="m-0" style={{ borderColor: 'var(--tomato-lighter-op)' }} />}
            </div>
          </React.Fragment>
        ))
      }
    </div>

  )
}
